import activesPhoto from '../static/images/advice_photos/actives.jpg';
import familyPhoto from '../static/images/advice_photos/family.jpg';
import monthlyPhoto from '../static/images/advice_photos/monthly.jpg';
import instagrammersPhoto from '../static/images/advice_photos/instagrammers.jpg';
import CategoryCardContainer from './CategoryCardContainer';
import CategoryCard from './CategoryCard';
import { useTranslation } from 'react-i18next';

const AdviceCategorySection = () => {
    const {t} = useTranslation();
    const transalatedTitles = [
        `${t('Homepage.AdviceCategorySection.monthAdvices')}`,
        `${t('Homepage.AdviceCategorySection.family')}`,
        `${t('Homepage.AdviceCategorySection.hard')}`,
        `${t('Homepage.AdviceCategorySection.instagrammers')}`
    ]
    return (
        <CategoryCardContainer>
            <CategoryCard photo={activesPhoto} title={transalatedTitles[0]} filterString="month" />
            <CategoryCard photo={familyPhoto} title={transalatedTitles[1]} filterString="family" />
            <CategoryCard photo={monthlyPhoto} title={transalatedTitles[2]} filterString="hard" />
            <CategoryCard photo={instagrammersPhoto} title={transalatedTitles[3]} filterString="instagrammers" />
        </CategoryCardContainer>
    )
}

export default AdviceCategorySection;